export default __webpack_public_path__ + "static/media/Rectangle_86.bdcff9a1.png";